import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMeasurements, getMeasurement } from '../../store/slices/measurementsSlice/action';
import { measurementsSelector } from '../../store/slices/measurementsSlice/measurementsSlice';
import { getFromLocalStorage } from '../../shared/helpers/localStorageHandler';
import { makeDecodeURL } from '../../shared/helpers/makeDecodeURL';
import { useTranslation } from 'react-i18next';

export const useEstimateMeasurements = () => {
    const { t } = useTranslation();

    const [isShowModal, setIsShowModal] = useState(true);
    const [imageList, setImageList] = useState([]);
    const [optionsList, setOptionsList] = useState([]);
    const { attachments, manualCalculations } = useSelector((state) => state.measurementsReducer);

    const measurementsIds = useSelector(measurementsSelector.selectIds);
    const measurementsList = useSelector(measurementsSelector.selectAll);

    const [isClosing, setIsClosing] = useState(false);
    const [currentUrl, setCurrentUrl] = useState('');
    const [currentIndex, setCurrentIndex] = useState(null);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isOpenPrevImage, setIsOpenPrevImage] = useState(false);
    const estimateMeasurementsContext = {
        imageList,
        setImageList,
        currentIndex,
        setCurrentIndex,
        optionsList,
        setOptionsList,
        currentUrl,
        setCurrentUrl,
        isOpenPrevImage,
        setIsOpenPrevImage,
        isShowModal,
        setIsShowModal,
    };
    const dispatch = useDispatch();

    const onHideEmptyMeasurementsModal = () => {
        setIsOpenModal(false);
    };

    useEffect(() => {
        dispatch(fetchMeasurements());
    }, [dispatch]);

    const updateImageList = useCallback(() => {
        if (attachments.ids.length) {
            const fetchData = async () => {
                const newData = await Promise.all(
                    Object.values(attachments.entities).map(async (file) => {
                        try {
                            const response = await fetch(file.url);
                            const blob = await response.blob();
                            const filename = makeDecodeURL(
                                file.url.substring(file.url.lastIndexOf('/') + 1)
                            );
                            const newFile = new File([blob], filename, { type: blob.type });

                            return {
                                file: newFile,
                                previewUrl: file.url,
                                id: file.id,
                            };
                        } catch (error) {
                            swal({
                                text: t('useEstimateMeasurements.updateImageList.swal.text'),
                                cancel: false,
                                confirm: true,
                                button: {
                                    text: t(
                                        'useEstimateMeasurements.updateImageList.swal.text.button'
                                    ),
                                    value: true,
                                    visible: true,
                                    className: 'btn btn-secondary',
                                },
                            });
                        }
                    })
                );

                const validData = newData.filter((item) => item !== null);

                setImageList(validData);
            };
            fetchData();
        } else {
            setImageList([]);
        }
    }, [attachments]);

    useEffect(() => {
        updateImageList();
    }, [manualCalculations.id, updateImageList]);

    useEffect(() => {
        if (measurementsIds.length) {
            measurementsList.map((measurement) =>
                setOptionsList((prev) => [
                    ...prev,
                    { title: measurement.name, value: measurement.id },
                ])
            );
            onHideEmptyMeasurementsModal();
            const localId = getFromLocalStorage('idMeasurement');
            const firstId = measurementsIds[0];
            const currentId = measurementsIds.includes(localId) ? localId : firstId;
            dispatch(getMeasurement(currentId));
        } else {
            setIsOpenModal(true);
        }
    }, [measurementsIds, measurementsList]);

    const onHideModal = () => {
        setIsOpenModal(false);
        setIsClosing(true);
        const valueBlock = document.querySelector('.bulk-action-bar');
        const valueOperation = document.querySelector('.modal.modalable-popup.show');
        const valueBlockStyle = window.getComputedStyle(valueBlock);
        const reactDiv = document.querySelector('#react-estimateMeasurements');
        setTimeout(() => {
            setIsShowModal(false);
            setIsClosing(false);

            if (valueBlockStyle.getPropertyValue('display') === 'none' && valueOperation === null) {
                document.querySelector('.table-column.react-icon.activeIcon').click();
            } else if (valueOperation !== null) {
                if (reactDiv) {
                    reactDiv.remove();
                }
            } else if (valueBlockStyle.getPropertyValue('display') !== 'none') {
                if (reactDiv) {
                    reactDiv.remove();
                }
            }
            $(document).find('.icon.icon-ruler.enableIcon').find('path').attr('fill', '#C1C4C9');
        }, 500);
    };

    const onHidePopup = () => {
        onHideEmptyMeasurementsModal();
        document.querySelector('.table-column.react-icon.activeIcon').click();
    };

    return {
        imageList,
        onHideModal,
        isClosing,
        optionsList,
        estimateMeasurementsContext,
        isOpenModal,
        onHideEmptyMeasurementsModal,
        onHidePopup,
        isOpenPrevImage,
        isShowModal,
    };
};
